enum DriverAddViewMode {
  TAXI = "TAXI",
  RAILY = "RAILY",
}

export default DriverAddViewMode;
